import * as z from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { type SubmitHandler, useForm } from "react-hook-form";
import type { AdminLoginFormProps } from "./AdminLoginForm.types";
import { vm } from "../../../../shared/utils/validationMessages";

const formSchema = z.object({
  citizenship_number: z
    .string()
    .trim()
    .min(1, { message: vm.CITIZENSHIP_REQUIRED })
    .regex(/^\d+$/, { message: vm.CITIZENSHIP_DIGITS_ONLY })
    .min(6, { message: vm.CITIZENSHIP_LENGTH })
    .max(10, { message: vm.CITIZENSHIP_LENGTH }),
  password: z.string().min(1, { message: vm.PASSWORD_REQUIRED }),
});

type FormSchema = z.infer<typeof formSchema>;

export const useAdminLoginForm = ({
  onLogin,
}: Omit<AdminLoginFormProps, "isSubmitting">) => {
  const form = useForm<FormSchema>({
    resolver: zodResolver(formSchema),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const onSubmit: SubmitHandler<FormSchema> = (data: FormSchema) => {
    onLogin(data);
  };

  return { form, onSubmit };
};
